import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import CustomButton from "../Button";

const DeeplinkRedirectPopup = ({
  open,
  title = "Acknowledgement Recorded",
  text,
  countdown,
  onReturn,
}) => (
  <Dialog
    fullWidth
    open={Boolean(open)}
    PaperProps={{
      sx: { borderRadius: "16px", margin: "24px", padding: "8px 4px" },
    }}
  >
    <DialogTitle sx={{ padding: "24px 24px 0px" }}>
      <Typography
        sx={{
          fontFamily: "FSElliotPro",
          fontSize: "20px",
          fontWeight: 700,
          lineHeight: 1.3,
          color: "#000",
        }}
      >
        {title}
      </Typography>
    </DialogTitle>
    <DialogContent sx={{ marginTop: "8px", paddingBottom: "24px" }}>
      <Typography
        sx={{
          fontFamily: "FSElliotPro",
          fontSize: "16px",
          lineHeight: 1.5,
          color: "#333",
        }}
      >
        {text} You will be automatically redirected back to the page you
        originally requested in{" "}
        <Typography
          component="span"
          sx={{
            fontFamily: "FSElliotPro",
            fontSize: "16px",
            fontWeight: 700,
            textDecoration: "underline",
            color: "#333",
          }}
        >
          {countdown} {countdown === 1 ? "second" : "seconds"}
        </Typography>
        .
      </Typography>
      <div style={{ marginTop: "24px" }}>
        <CustomButton
          variant="contained"
          text="Return Now"
          color="#fff"
          backgroundColor="#1278CC"
          onClick={onReturn}
          testId="deeplink-return-now"
        />
      </div>
    </DialogContent>
  </Dialog>
);

export default DeeplinkRedirectPopup;
